module.exports = __webpack_public_path__ + "static/media/diners.48148d1d.svg";